import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from '../CtaButton';
import { GoldSeal } from '../GoldSeal';
import { MOCKUP_URL } from '../../data/offer';
import { LazyImage } from '../LazyImage';
export function Hero() {
  return <header className="bg-cream" data-id="element-193" data-mp="cuji64m195wj">
      <div className="mx-auto max-w-3xl px-5 pb-8 pt-7 text-center sm:px-8 sm:pb-12 sm:pt-12 lg:pb-16" data-id="element-194" data-mp="huxptljq2du1">
        <p className="mx-auto max-w-md text-[11px] font-semibold uppercase leading-relaxed tracking-[0.16em] text-sage-700" data-id="element-195" data-mp="muad27ei9mx5">
          Para sexólogos/as, psicólogos/as y profesionales que trabajan con sexualidad
        </p>
        <h1 className="mt-3 font-serif text-[2.3rem] leading-[1.02] text-petrol-800 text-balance sm:mt-5 sm:text-6xl lg:text-[4.4rem]" data-id="element-196" data-mp="vm2nii3j4w1q">
          Todo un año de material profesional, <span className="italic text-terra-500" data-id="element-197" data-mp="15ks66d392kj1">listo para usar.</span>
        </h1>

        {/* Mockup principal al 70% (imagen 1:1) */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-5 aspect-square w-[70%] max-w-[392px] sm:mt-8" data-id="element-198" data-mp="1akejemj2w0ru">
          <LazyImage priority src={MOCKUP_URL} width={1254} height={1254} sizes="(min-width: 640px) 392px, 70vw" alt="Kit Sexualidad Práctica: 7 módulos, 5 bonos, fichas de evaluación, plan de intervención y sesiones listas" className="h-full w-full object-contain mix-blend-multiply" data-id="element-199" data-mp="3vw2borgruoos" />
          <div className="absolute -bottom-1 -left-6 sm:hidden" data-id="element-200" data-mp="nephmts65g9n">
            <GoldSeal size={68} data-id="element-201" data-mp="nhk0whzg4v1h" />
          </div>
          <div className="absolute -bottom-2 -left-14 hidden sm:block" data-id="element-202" data-mp="infsrveg2gyt">
            <GoldSeal size={100} data-id="element-203" data-mp="enfd67flzzq6" />
          </div>
        </motion.div>

        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink/80 sm:mt-8 sm:text-lg" data-id="element-204" data-mp="el2x5ztevzfr">
          <strong className="font-semibold text-petrol-800" data-id="element-205" data-mp="1b6msoinso49p">Kit Sexualidad Práctica</strong>  te brinda{' '}
          <strong className="font-semibold text-petrol-800" data-id="element-206" data-mp="30lxcg6nde4v4">
            sesiones, fichas, preguntas guía, ejercicios y herramientas profesionales
          </strong>{' '}
          listas para usar en tu práctica.
        </p>
        <p className="mx-auto mt-3 hidden max-w-xl text-[15px] leading-relaxed text-ink/60 sm:block" data-id="element-207" data-mp="2qww14trrsbnh">
          Tené tus recursos organizados en un solo lugar y accedé a ellos fácilmente desde tu celular, tablet o computadora.
        </p>
        <div className="mt-6 flex flex-col items-center gap-2.5 sm:mt-8 sm:gap-3" data-id="element-208" data-mp="2hu4kmfk1epoz">
          <CtaButton className="w-full sm:w-auto" data-id="element-209" data-mp="2mvafaix9cn15" />
          <p className="text-[13px] text-ink/60" data-id="element-210" data-mp="27xi1pwb9u8pl">Acceso digital inmediato • Disponible desde cualquier dispositivo</p>
        </div>
      </div>
    </header>;
}